import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    styled,
    useTheme,
    Chip,
    IconButton,
    Tooltip, 
    Paper
} from "@mui/material";
import { CheckCircle, Cancel, Edit } from "@mui/icons-material";
import { useState } from "react";
import MarkAttendanceModal from "./MarkAttendanceModal";
import apiService from "Network/apiService";
import { API_ENDPOINTS } from "Network/apiEndpoints";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: "16px 20px",
    color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black,
    borderBottom: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
    whiteSpace: "nowrap",
    "&.header": {
        fontWeight: 600,
        fontSize: "0.875rem",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:hover": {
        backgroundColor: theme.palette.mode === 'dark' 
            ? "rgba(255, 255, 255, 0.05)" 
            : "rgba(0, 0, 0, 0.05)",
    },
    "& > .MuiTableCell-root": {
        borderBottom: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
    },
}));

const MembersTable = ({ members, searchQuery, selectedDate, onAttendanceMarked, chapterId, chapterMeetingId, startTime }) => {
    const theme = useTheme();
    const [openModal, setOpenModal] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);

    const filteredMembers = members.filter(member => {
        if (!searchQuery) return true;
        const searchLower = searchQuery.toLowerCase();
        return (
            member.full_name?.toLowerCase().includes(searchLower) ||
            member.company_name?.toLowerCase().includes(searchLower) ||
            member.email?.toLowerCase().includes(searchLower)
        );
    });

    const handleAttendanceClick = (member) => {
        setSelectedMember(member);
        setOpenModal(true);
    };

    return (
        <Box sx={{ width: "100%", p: 2 }}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell className="header">Name</StyledTableCell>
                            <StyledTableCell className="header">Company</StyledTableCell>
                            <StyledTableCell className="header">Email</StyledTableCell>
                            <StyledTableCell className="header">Contact</StyledTableCell>
                            <StyledTableCell className="header">City</StyledTableCell>
                            <StyledTableCell className="header" align="center">Status</StyledTableCell>
                            <StyledTableCell className="header" align="center">Action</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredMembers.map((member) => (
                            <StyledTableRow key={member.id}>
                                <StyledTableCell>{member.full_name}</StyledTableCell>
                                <StyledTableCell>{member.company_name}</StyledTableCell>
                                <StyledTableCell>{member.email}</StyledTableCell>
                                <StyledTableCell>{member.contact_no}</StyledTableCell>
                                <StyledTableCell>{member.city}</StyledTableCell>
                                <StyledTableCell align="center">
                                    <Chip
                                        label={member.is_present 
                                            ? `Present (${member.time?.substring(0, 5) ? member.time :"NA"})` 
                                            : `Absent`}
                                        color={member.is_present ? "success" : "error"}
                                        size="small"
                                        icon={member.is_present ? <CheckCircle /> : <Cancel />}
                                        sx={{ minWidth: '120px' }}
                                    />
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <Tooltip title={member.is_present ? "Update Attendance" : "Mark Attendance"}>
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAttendanceClick(member)}
                                            sx={{
                                                color: theme.palette.primary.main,
                                                '&:hover': {
                                                    backgroundColor: theme.palette.primary.main + '20'
                                                }
                                            }}
                                        >
                                            <Edit fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <MarkAttendanceModal
                open={openModal}
                onClose={() => {
                    setOpenModal(false);
                    setSelectedMember(null);
                }}
                member={selectedMember}
                selectedDate={selectedDate}
                chapterId={chapterId}
                chapterMeetingId={chapterMeetingId}
                onSuccess={() => {
                    onAttendanceMarked();
                    setOpenModal(false);
                }}
                startTime={startTime}
            />
        </Box>
    );
};

export default MembersTable;